import {ChangeDetectionStrategy, Component, computed, effect, inject, input} from '@angular/core';
import moment from 'moment';
import {HarbourDuesBerthVisit, HarbourDuesRotterdamResponse} from '@portbase/bezoekschip-service-typescriptmodels';
import {HarbourDuesCargoService} from '../../../../services/harbour-dues-cargo.service';
import {FormArray, FormGroup, FormGroupDirective} from '@angular/forms';
import {toSignal} from '@angular/core/rxjs-interop';
import {AlertSeverity} from '../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-berth-visit-rotterdam',
  templateUrl: './berth-visit-rotterdam.component.html',
  styleUrl: './berth-visit-rotterdam.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BerthVisitRotterdamComponent {
  protected readonly AlertSeverity = AlertSeverity;

  readonly berthVisitNumber = input.required<number>();
  readonly berthVisit = input.required<HarbourDuesBerthVisit>();
  readonly harbourDuesDetails = input.required<HarbourDuesRotterdamResponse>();
  readonly vesselDeadWeightKg = input<number>();
  readonly showValidationErrors = input<boolean>(false);

  private readonly cargoService = inject(HarbourDuesCargoService);
  private readonly form = inject(FormGroupDirective);

  private readonly HarbourDuesVisit = toSignal<{berthVisits: HarbourDuesBerthVisit[]}>(
    this.form.control.valueChanges,
    { initialValue: this.form.control.value }
  );

  protected readonly harbourDuesBerthVisit = computed(
    () => this.HarbourDuesVisit()?.berthVisits.at(this.berthVisitNumber())
  );

  protected readonly berthVisitDuration = computed(() => {
    if (this.berthVisit().ata) {
      const start = moment(this.berthVisit().ata);
      const end = this.berthVisit().atd
          ? moment(this.berthVisit().atd): moment();
      const duration = moment.duration(start.diff(end));
      return duration.humanize()
    }
    return "Unknown";
  });

  protected readonly isCargoDeltaExceedingDeadWeight = computed(() => {
    const berthVisit = this.harbourDuesBerthVisit();
    if (!berthVisit) {
      return false;
    }
    return this.cargoService.isBerthVisitGoodsDeltaExceedingWeight(
      berthVisit, this.vesselDeadWeightKg()
    );
  }, {equal: () => false});

  protected readonly vesselDeadWeightTons = computed(
    () => (this.vesselDeadWeightKg() || 0) / 1000
  );

  constructor() {
    effect(() => {
      const berthVisits = this.form.control.get('berthVisits') as FormArray;
      const berthVisit = berthVisits.at(this.berthVisitNumber()) as FormGroup;
      berthVisit.setErrors(
        this.isCargoDeltaExceedingDeadWeight() ?
          { deadweight: true } : null
      );
    });
  }
}
